/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nda_Download_Copy_BtnInputs */



/**
* | output |
* | --- |
* | "Download your copy" |
*
* @param {Nda_Download_Copy_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const nda_download_copy_btn = /** @type {((inputs?: Nda_Download_Copy_BtnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nda_Download_Copy_BtnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Télécharger votre copie")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descargar su copia")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Baixar sua cópia")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scarica la tua copia")
	return /** @type {LocalizedString} */ ("Download your copy")
});